import React from 'react';
import { connect } from 'react-redux';

const Winner = (props) => {
  if (!props.gameWinner)
    return null;
  return ( 
    <div>
      <h1>Game Over</h1>
      <h2>{props.gameWinner === 'Draw' ? 'Draw' : `Player ${props.gameWinner} wins`} </h2>
    </div>
  );
}

const mapStateToProps = (state) => {
  console.log(state.grid, state.totalTurns, state.gameWinner, 'winner')
  return {
    gameWinner: state.gameWinner
  }
}
export default connect(mapStateToProps)(Winner);